const getters = {
  searchType: (state) => state.searchType,
  searchValue: (state) => state.searchValue,
  subtype: (state) => state.subtype,
  currentArea: (state) => state.currentArea,
  mapObject: (state) => state.mapObject,
  mapObject: (state) => state.mapObject,
  geoLocation: (state) => state.geoLocation,
  hallList: (state) => state.hallList,
  prohallList: (state) => state.prohallList,
  driving: (state) => state.driving,  // 驾车
  transfer: (state) => state.transfer,  // 公交
  walking: (state) => state.walking,  // 步行
  isFitView: (state) => state.isFitView,  // 步行
  isHideMarkerInfo: (state) => state.isHideMarkerInfo,  // 地图缩放级别大时，隐藏label
  tagsNames: (state) => state.tagsNames,
  zxblStatus: (state) => state.zxblStatus,
  proSort: (state) => state.proSort,
  itemCodeMap: (state) => state.itemCodeMap,
  cityOfficeCode: (state) => state.cityOfficeCode
}
export default getters
